export var NotificationType;
(function(NotificationType) {
    NotificationType[NotificationType["Collect"] = 0] = "Collect";
    NotificationType[NotificationType["CollectUndo"] = 1] = "CollectUndo";
    NotificationType[NotificationType["AddToGroup"] = 2] = "AddToGroup";
    NotificationType[NotificationType["AddToGroupUndo"] = 3] = "AddToGroupUndo";
    NotificationType[NotificationType["Fave"] = 4] = "Fave";
    NotificationType[NotificationType["FaveUndo"] = 5] = "FaveUndo";
    NotificationType[NotificationType["DeleteComment"] = 6] = "DeleteComment";
    NotificationType[NotificationType["PostComment"] = 7] = "PostComment";
    NotificationType[NotificationType["Live"] = 8] = "Live";
    NotificationType[NotificationType["Generic"] = 9] = "Generic";
    NotificationType[NotificationType["GenericUndo"] = 10] = "GenericUndo";
    NotificationType[NotificationType["Badge"] = 11] = "Badge";
    NotificationType[NotificationType["CollectPrivate"] = 12] = "CollectPrivate";
})(NotificationType || (NotificationType = {}));

//# sourceMappingURL=types.js.map